<p-floatlabel variant="on">
  <ng-content></ng-content>
</p-floatlabel>
